import { createSlice } from "@reduxjs/toolkit";

const initialLandingPageState = {
  listLoading: false,
  actionsLoading: false,
  lastError: null,
  postSaveResponse: {}
};
export const callTypes = {
  list: "list",
  action: "action",
};

export const LandingPageSlice = createSlice({
  name: "LandingPage",
  initialState: initialLandingPageState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      state.postSaveResponse = {};
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getAnchorById
    postSaved: (state, action) => {
      state.actionsLoading = false;
      state.postSaveResponse = action.payload.data;
      state.error = null;
    },
  },
});